import React,{useEffect} from 'react';
import ReactDOM from 'react-dom';

const CRMHome = () => {
  // Example array of dummy contacts
  const contacts = [
    { id: 1, name: 'Alice Johnson', email: 'alice@example.com', phone: '555-0123' },
    { id: 2, name: 'Bob Smith', email: 'bob@example.com', phone: '555-0456' },
    { id: 3, name: 'Charlie Brown', email: 'charlie@example.com', phone: '555-0789' },
    { id: 4, name: 'David Wilson', email: 'david@example.com', phone: '555-1234' },
    { id: 5, name: 'Eva Green', email: 'eva@example.com', phone: '555-5678' },
    { id: 6, name: 'Frank Ocean', email: 'frank@example.com', phone: '555-0001' },
    { id: 7, name: 'Grace Lee', email: 'grace@example.com', phone: '555-2222' },
    { id: 8, name: 'Hannah Kim', email: 'hannah@example.com', phone: '555-3333' },
    { id: 9, name: 'Isaac Newton', email: 'isaac@example.com', phone: '555-4444' },
    { id: 10, name: 'Jack Daniels', email: 'jack@example.com', phone: '555-5555' },
  ];



    // Updated buttonIds to include direction
    const buttonIds = [
      { id: 'home', direction: 'bottom' },
      { id: 'profiles', direction: 'bottom' },
      { id: 'notifications', direction: 'bottom' },
      { id: 'contact-1', direction: 'right' },
      // { id: 'item2', direction: 'right' },
    ]; // Add more button IDs as needed
  
    const startTour = () => {
      // Create a new script element to hold the Vanilla JS code
      const script = document.createElement('script');
      script.innerHTML = `
        let currentStep = 0;
        let buttons = [];
        let overlay, tooltip;
  
        function initializeTour(buttonData) {
          buttons = buttonData;
          currentStep = 0;
          createOverlay();
          highlightButton();
        }
  
        function createOverlay() {
          overlay = document.createElement('div');
          overlay.style.position = 'fixed';
          overlay.style.top = '0';
          overlay.style.left = '0';
          overlay.style.width = '100%';
          overlay.style.height = '100%';
          overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.4)';
          overlay.style.zIndex = '9999';
          overlay.style.display = 'flex';
          overlay.style.justifyContent = 'center';
          overlay.style.alignItems = 'center';
          document.body.appendChild(overlay);
          
          tooltip = document.createElement('div');
          tooltip.style.backgroundColor = '#fff';
          tooltip.style.padding = '20px';
          tooltip.style.borderRadius = '8px';
          tooltip.style.boxShadow = '0px 4px 8px rgba(0, 0, 0, 0.2)';
          tooltip.style.position = 'absolute';
          tooltip.style.zIndex = '10000';
          overlay.appendChild(tooltip);
          
          const nextButton = document.createElement('button');
          nextButton.textContent = currentStep === buttons.length - 1 ? 'Finish Tour' : 'Next';
          nextButton.style.marginTop = '10px';
          nextButton.onclick = nextTourStep;
  
          tooltip.appendChild(document.createElement('p')).innerText = \`This is \${buttons[currentStep].id}\`;
          tooltip.appendChild(nextButton);
  
          positionTooltip(buttons[currentStep]);
        }
  
        function highlightButton() {
          const button = document.getElementById(buttons[currentStep].id);
          if (button) {
            button.style.backgroundColor = '#ffeb3b'; // Highlight color
            button.style.border = '2px solid #4CAF50'; // Optional border
          }
        }
  
        function positionTooltip(buttonData) {
          const button = document.getElementById(buttonData.id);
          if (button) {
            const rect = button.getBoundingClientRect();
            if (buttonData.direction === 'bottom') {
              tooltip.style.top = rect.bottom + window.scrollY + 'px'; // Positioning below the button
              tooltip.style.left = rect.left + (rect.width / 2) + 'px'; // Center tooltip under the button
              tooltip.style.transform = 'translateX(-50%)'; // Adjust for centering
            } else if (buttonData.direction === 'right') {
              tooltip.style.top = rect.top + window.scrollY + 'px'; // Align with the button vertically
              tooltip.style.left = rect.right + 'px'; // Position tooltip to the right of the button
            }
          } else {
            alert(\`Button \${buttonData.id} not found\`);
          }
        }
  
        function nextTourStep() {
          if (currentStep < buttons.length - 1) {
            const button = document.getElementById(buttons[currentStep].id);
            if (button) {
              button.style.backgroundColor = ''; // Reset color
              button.style.border = ''; // Reset border
            }
            currentStep++;
            highlightButton();
            tooltip.querySelector('p').innerText = \`This is \${buttons[currentStep].id}\`;
            const nextButton = tooltip.querySelector('button');
            nextButton.textContent = currentStep === buttons.length - 1 ? 'Finish Tour' : 'Next';
            positionTooltip(buttons[currentStep]);
          } else {
            endTour();
          }
        }
  
        function endTour() {
          const button = document.getElementById(buttons[currentStep].id);
          if (button) {
            button.style.backgroundColor = ''; // Reset color
            button.style.border = ''; // Reset border
          }
          overlay.remove();
        }
  
        // Start the tour when this script is run
        initializeTour(${JSON.stringify(buttonIds)});
      `;
  
      document.body.appendChild(script);
      
      // Cleanup script when the tour ends
      const cleanupScript = () => {
        document.body.removeChild(script);
      };
  
      const endTour = () => {
        cleanupScript();
        alert("Tour ended.");
      };
  
      // Make sure to call endTour when appropriate (for example, if you want to end it when clicking on the overlay)
      script.innerHTML += '\noverlay.onclick = endTour;';
    };
  
    useEffect(() => {
      // Add event listener for the Take A Tour button
      const takeATourButton = document.getElementById('take-a-tour-button');
      if (takeATourButton) {
        takeATourButton.addEventListener('click', startTour);
      }
  
      // Cleanup listener on component unmount
      return () => {
        if (takeATourButton) {
          takeATourButton.removeEventListener('click', startTour);
        }
      };
    }, []);



  return (
    <div className="crm-home">
      <header className="header">
        <h1>CRM Home</h1>
        <nav className="nav">
          <ul>
            <li id="home">Home</li>
            <li id="profiles">Profile</li>
            <li id="notifications">Notifications</li>
            <li id="take-a-tour-button">Take A Tour</li>
          </ul>
        </nav>
      </header>
      <div className="content">
        <aside className="sidebar">
          <h2>Menu</h2>
          <ul>
            <li>Dashboard</li>
            <li>Contacts</li>
            <li>Reports</li>
            <li>Settings</li>
          </ul>
        </aside>
        <main className="main-content">
          <div className="contact-list">
            {contacts.map(contact => (
              <div key={contact.id} id={`contact-${contact.id}`} className="contact-card">
                <h2>{contact.name}</h2>
                <p>Email: {contact.email}</p>
                <p>Phone: {contact.phone}</p>
              </div>
            ))}
          </div>
        </main>
      </div>
      <footer className="footer">
        <p>&copy; 2024 CRM Application. All Rights Reserved.</p>
      </footer>
      <style>{`
        .crm-home {
          display: flex;
          flex-direction: column;
          height: 100vh;
          font-family: 'Arial', sans-serif;
          color: #343a40;
        }

        .header {
          background-color: #007bff;
          color: white;
          padding: 20px;
          text-align: center;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        }

        .nav {
          margin-top: 10px;
        }

        .nav ul {
          list-style: none;
          padding: 0;
          display: flex;
          justify-content: center;
          gap: 15px; /* Space between nav items */
        }

        .nav li {
          cursor: pointer;
          padding: 8px 12px;
          border-radius: 5px;
          transition: background-color 0.3s, color 0.3s;
        }

        .nav li:hover {
          background-color: rgba(255, 255, 255, 0.2); /* Light hover effect */
          color: #e9ecef; /* Change text color on hover */
        }

        .content {
          display: flex;
          flex: 1;
        }

        .sidebar {
          background-color: #f8f9fa;
          padding: 20px;
          width: 250px;
          border-right: 1px solid #ddd;
          box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
        }

        .sidebar h2 {
          font-size: 1.5em;
          margin-bottom: 15px;
        }

        .sidebar ul {
          list-style: none;
          padding: 0;
        }

        .sidebar li {
          margin: 10px 0;
          padding: 8px;
          border-radius: 5px;
          transition: background-color 0.3s;
        }

        .sidebar li:hover {
          background-color: #e9ecef; /* Light grey on hover */
          cursor: pointer;
        }

        .main-content {
          flex: 1;
          padding: 20px;
          overflow-y: auto; /* Enable scrolling if content exceeds viewport */
        }

        .contact-list {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 20px;
        }

        .contact-card {
          background-color: white;
          border: 1px solid #ccc;
          border-radius: 8px;
          padding: 20px;
          box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
          transition: transform 0.2s, box-shadow 0.2s;
        }

        .contact-card:hover {
          transform: translateY(-3px);
          box-shadow: 4px 4px 15px rgba(0, 0, 0, 0.2);
        }

        .contact-card h2 {
          font-size: 1.3em;
          margin: 0 0 10px;
        }

        .footer {
          background-color: #343a40;
          color: white;
          text-align: center;
          padding: 15px;
          position: relative;
          bottom: 0;
          width: 100%;
        }
      `}</style>
    </div>
  );
};

export default CRMHome;
